/**
 * Auth types and enums.
 * This file exists to break circular dependencies between brightback-auth.slice.ts and brightback-auth.ts
 */

import {
  type ChargebeeGetSignInUrlArgs,
  type ChargebeeSignInArgs,
} from '@bbkAdminUtils/auth-chargebee';
import { type DevSignInArgs } from '@bbkAdminUtils/auth-dev';
import { type GoogleSignInArgs } from '@bbkAdminUtils/auth-google';
import { type UsernameSignInArgs } from '@bbkAdminUtils/auth-username';

export enum SignInType {
  'USERNAME' = 'USERNAME',
  'DEV' = 'DEV',
  'GOOGLE' = 'GOOGLE',
  'CHARGEBEE' = 'CHARGEBEE',
}

export type SignInTokens = {
  type: SignInType;
  access_token: string;
  refresh_token: string;
  exp: number; // expires at
};

export type SignInArgs =
  | ({
      type: SignInType.USERNAME;
    } & UsernameSignInArgs)
  | ({
      type: SignInType.DEV;
    } & DevSignInArgs)
  | ({
      type: SignInType.GOOGLE;
    } & GoogleSignInArgs)
  | ({
      type: SignInType.CHARGEBEE;
    } & ChargebeeSignInArgs);

export type GetSignInUrlArgs = {
  type: SignInType.CHARGEBEE;
} & ChargebeeGetSignInUrlArgs;
